import { io, Socket } from 'socket.io-client';
import type { ServerToClientEvents, ClientToServerEvents, SocketRoom } from '@taj/types';

// Même origine que la page (le temps réel est relayé sur /socket.io).
// → fonctionne en local, sur le wifi ET à distance via un tunnel.
const URL = import.meta.env.VITE_SOCKET_URL ?? location.origin;

export const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io(URL, {
  autoConnect: false,
  path: '/socket.io',
  transports: ['websocket', 'polling'],
});

export function joinRoom(room: SocketRoom) {
  const doJoin = () => socket.emit('join', room);
  if (socket.connected) doJoin();
  socket.on('connect', doJoin);
}
